import { RFParamSetElement } from "./rf-paramset-element.model";

export class NetworkServerModel {
  owner: string = "";
  name: string = "";
  netIds: Array<string>;
  devAddrRange: Array<string>;
  nsId: string;
  url_fns: string;
  url_sns: string;
  url_hns: string;
  url: string;
  platformId: string;
  protocolVersion: string;
  alarm: string;
  security: string;
  authType: string;
  authUsername: string;
  authPassword: string;
  subscriberId: string;
  nsGroupId: string;
  subnwkId: string;
  heliumMember: boolean;
  rfParamSets: Array<RFParamSetElement> = [];

  constructor(
    owner: string = "",
    netIds: Array<string> = [],
    devAddrRange: Array<string> = [],
    nsId: string = "",
    name: string = "",
    url_fns: string = "",
    url_sns: string = "",
    url_hns: string = "",
    platformId: string = '1',
    protocolVersion: string = '1.1',
    alarm: string = '0',
    security: string = "SSL",
    authType: string = "None",
    authUsername: string = null,
    authPassword: string = null,
    subscriberId: string = null,
    nsGroupId: string = null,
    subnwkId: string = null,
    heliumMember: boolean = false,
    rfParamSets: Array<RFParamSetElement> = []
  ) {
    this.owner = owner;
    this.name = name;
    this.netIds = netIds;
    this.devAddrRange = devAddrRange;
    this.nsId = nsId;
    this.url_fns = url_fns;
    this.url_sns = url_sns;
    this.url_hns = url_hns;
    this.platformId = platformId;
    this.protocolVersion = protocolVersion;
    this.alarm = alarm;
    this.security = security;
    this.authType = authType;
    this.authUsername = authUsername;
    this.authPassword = authPassword;
    this.subscriberId = subscriberId;
    this.nsGroupId = nsGroupId;
    this.subnwkId = subnwkId;
    this.heliumMember = heliumMember;
    this.rfParamSets = rfParamSets;
  }

  addNetId(netId: string) {
    this.netIds.push(netId)
    this.nsGroupId = null;
  }

  editNetId(index: string, value: string) {
    if(value != "") {
      this.netIds[index] = value;
      this.nsGroupId = null;
    } else {
      this.removeNetId(index)
    }
  }

  removeNetId(index) {
    this.netIds.splice(index, 1);
  }

  addRfParamSet(rfParamSet: RFParamSetElement) {
    this.rfParamSets.push(rfParamSet);
  }

  removeRfParamSet(index) {
    this.rfParamSets.splice(index, 1)
  }


}
